import React, { useState } from 'react'
import { Button, TextField } from '@mui/material'
import greenIcon from "../assets/ReviseIconGreen.svg";

export default function GoogleAdsFooterComponent({
  handleGenerateButtonClick,
  callToAction,
  AdType,
  flagRegenerated,
  revisedData
}) {
  const regenerateButtonStyles = {
    width: "100%",
    marginTop: "1.5rem",
    color: "#4F4830",
    background: "#EFC634",
    height: "12",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#FAF0D2", 
      cursor: "pointer"
    }
  }
  const reviseButtonStyles = {
    marginTop: "1.5rem",
    width: "12%",
    height: "12",
    color: "#4F4830",
    fontWeight: "bold",
    background: "#EFC634",
    "&:hover": {
      backgroundColor: "#FAF0D2", 
      cursor: "pointer"
    }
  }
  
  const [revisedInfo, setRevisedInfo] = useState("");

  const handleAdsRegenerate = () => {
    handleGenerateButtonClick(AdType, flagRegenerated);
  }
  
  const handleReviseGenerate = () => {
    revisedData(revisedInfo, AdType);
  }
  return (
    <div>
			<div className='w-[100%] bg-[#F2F2F2] p-3 mt-4 rounded-lg flex justify-between align-center'>
        <div className='font-bold text-[0.9rem] mt-2 ml-2 p-2'>Call to action</div>
        <div className='h-[2.3rem] w-[85%] bg-white rounded-lg mt-2 flex justify-between border-2 border-gray-250 p-1.5'>
          <p>{callToAction}</p>
        </div>
			</div>

      <div className='flex justify-between align-center mt-4'>
        <div className='w-[85%]'>
          <p className="text-label mb-2 text-black">Ask for revisions</p>
          <TextField
            fullWidth
            color="tertiary"
            defaultValue=""
            focused
            value={ revisedInfo }
            onChange={(e) => {
              setRevisedInfo(e.target.value);
            }}
            inputProps={{
              sx: {
                height: 12,
              },
            }}
          ></TextField>
        </div>
        <Button 
          sx={ reviseButtonStyles }
          onClick={ handleReviseGenerate }
          disabled={ revisedInfo.length === 0 ? true : false }
          variant={
            !revisedInfo
              ? "contained"
              : "outlined"
          }
          color="secondary"
        >
          <img
            src={!revisedInfo
              ? require("../assets/reviseIcon.png")
              : greenIcon}
            className='mr-1.5 h-6 w-6'
          >
          </img>
          REVISE
        </Button>
      </div>
      <Button 
        sx={ regenerateButtonStyles }
        onClick={ handleAdsRegenerate }
      >REGENERATE</Button>
    </div>
  )
}
